import { PermissionResource } from '@entities/tenant/permission';

import { requirePermission } from '../../../require-permission';

export const limitTemplatesLoader = requirePermission(PermissionResource.TenantLimits);
